import {MonitorReducer, ReducerFromState} from "../../../@types/reducers";
import {AlertMonitorObject} from "../../../@types/response";

export const getMonitors = (state: ReducerFromState<MonitorReducer>): Array<AlertMonitorObject> => state.monitor.monitors;
